export default __webpack_public_path__ + "static/award3-b8ac53c95d4068474130e0934b7ff7cc.jpg";